module.exports = __webpack_public_path__ + "img/stop.9d0bbe09.svg";